import { getBugSnagger } from '../initialisers/BugSnag';

type Props = {
  message?: string;
  code?: string;
  response?: {
    status?: number;
    data: { errors: Array<Error> };
    config?: {
      url: string;
    };
  };
};

function snagError(error: Props) {
  if (
    error &&
    error.response &&
    (error.response.status === 408 || error.response.status === 404)
  ) {
    getBugSnagger().notify(error, {
      metaData: {
        url: error.response.config!.url,
      },
    });
  }
}

export default function handleRequestError(error?: Props) {
  let info = new Error('false');
  if (error && error.response) {
    const e = error.response.data;
    if (e && e.errors && e.errors.length > 0) {
      [info] = e.errors;
    }
  }
  if (error) {
    snagError(error);
  }
  throw info;
}
